import { withCustomProductPage } from "components/common/customProductPage";
import { ONELINK_URL } from "components/website/bioLinks";

/**
 * The OneLink behind a partner page's "Get Stippl" buttons; `campaign` says which button it was. The trailing slash
 * after the template matters: iOS only opens an installed app from `/cgUq/…` (see useAppsflyerOneLink.ts). Carries
 * the Custom Product Page id like every other OneLink the site builds.
 */
export const oneLinkUrl = (pid: string, campaign: string): string =>
	withCustomProductPage(`${ONELINK_URL}/?pid=${encodeURIComponent(pid)}&c=${encodeURIComponent(campaign)}`);

/** The utm query of a link from a partner page, to the partner's site or to stippl.io. */
export const utmParams = (source: string, campaign: string): string =>
	`utm_source=${encodeURIComponent(source)}&utm_medium=partner&utm_campaign=${encodeURIComponent(campaign)}`;
